import { Form, Input, Select } from 'antd';
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import FormPage from '../../../../../components/pages/FormPage'

const DefModel = {
    no_aju: '',
    no_increment: 0,
    name: '',
    airline_id: null
}

export default () => {
    const [model, setModel] = useState(DefModel);
    const { airlineCache } = useSelector(state => state.apps);
    const airlineOptions = (Array.isArray(airlineCache) ? airlineCache : []).map(item => ({
        value: `${item?._id || ''}`,
        label: `${item?.name || ''}`,
    }));

    const normalizeMasterAjuPayload = (values) => ({
        ...values,
        airline_id: typeof values?.airline_id === 'object'
            ? values?.airline_id?._id || null
            : values?.airline_id || null
    });

    return (
        <FormPage
            url={'api/v1/master_aju'}
            model={model}
            setModel={setModel}
            wrapperCol={{ span: 8 }}
            labelCol={{ span: 3 }}
            title={"Master Aju"}
            emptyModel={DefModel}
            callbackPath={"/master/aju"}
            onEditFormEvent={(values) => normalizeMasterAjuPayload(values)}
            onSaveEvent={(values) => normalizeMasterAjuPayload(values)}
        >
            <Form.Item name={'no_aju'} label="No Aju" rules={[{ required: true }]}>
                <Input autoFocus />
            </Form.Item>
            <Form.Item name={'airline_id'} label="Airline">
                <Select
                    showSearch
                    allowClear
                    options={airlineOptions}
                    optionFilterProp="label"
                    filterOption={(inputValue, option) => {
                        const keyword = inputValue.toUpperCase();
                        return option?.label?.toUpperCase().includes(keyword);
                    }}
                />
            </Form.Item>
            <Form.Item name={'no_increment'} label="No Increment" rules={[{ required: true }]}>
                <Input type='number' />
            </Form.Item>
            <Form.Item name={'name'} label="Name" rules={[{ required: true }]}>
                <Input />
            </Form.Item>
        </FormPage>
    )
}
